interface TranslationStrings {
  nav: { travel: string; education: string; healthcare: string; howItWorks: string; partners: string; faq: string; signIn: string; myAccount: string; signOut: string; contact: string; partnerWithUs: string };
  hero: { headline: string; subtext: string; cta: string; howItWorks: string };
  verticals: { travel: string; education: string; healthcare: string };
  common: { perMonth: string; from: string; bookNow: string; learnMore: string; earnPoints: string; points: string; aed: string; sendOTP: string; verifyCode: string; signOut: string; getEarlyAccess: string };
  trust: { bnplReady: string; flexibleTerms: string; bankGradeSecurity: string; securePlatform: string; bankLevelEncryption: string; sslProtected: string; yourDataIsSafe: string; licensedPartners: string; uaeRegulatedProviders: string; trustedMarketplace: string; verifiedMerchants: string };
}

export const translations: Record<'en' | 'ar', TranslationStrings> = {
  en: {
    nav: {
      travel: 'Flex Travel',
      education: 'Flex Education',
      healthcare: 'Flex Healthcare',
      howItWorks: 'How it Works',
      partners: 'Partners',
      faq: 'FAQ',
      signIn: 'Sign In',
      myAccount: 'My Account',
      signOut: 'Sign Out',
      contact: 'Contact',
      partnerWithUs: 'Partner with us',
    },
    hero: {
      headline: 'Your Next Holiday. From AED 500 a Month.',
      subtext: 'Search, compare and book flights, hotels and packages worldwide — with flexible payment options from UAE\'s leading providers, built in.',
      cta: 'Explore Travel',
      howItWorks: 'How it Works',
    },
    verticals: {
      travel: 'Travel',
      education: 'Education',
      healthcare: 'Healthcare',
    },
    common: {
      perMonth: '/month',
      from: 'From',
      bookNow: 'Book Now',
      learnMore: 'Learn More',
      earnPoints: 'Earn',
      points: 'pts',
      aed: 'AED',
      sendOTP: 'Send One-Time Code',
      verifyCode: 'Verify Code',
      signOut: 'Sign Out',
      getEarlyAccess: 'Get Early Access',
    },
    trust: {
      bnplReady: 'BNPL-Ready',
      flexibleTerms: 'Flexible Terms',
      bankGradeSecurity: '256-bit Encrypted & Secure',
      securePlatform: 'Secure Platform',
      bankLevelEncryption: '256-bit encrypted & secure',
      sslProtected: 'SSL Protected',
      yourDataIsSafe: 'Your data is safe',
      licensedPartners: 'Licensed Partners',
      uaeRegulatedProviders: 'UAE regulated providers',
      trustedMarketplace: 'Trusted Marketplace',
      verifiedMerchants: 'Verified merchants',
    },
  },
  ar: {
    nav: {
      travel: 'سفر فلكس',
      education: 'تعليم فلكس',
      healthcare: 'رعاية صحية فلكس',
      howItWorks: 'كيف يعمل',
      partners: 'الشركاء',
      faq: 'الأسئلة الشائعة',
      signIn: 'تسجيل الدخول',
      myAccount: 'حسابي',
      signOut: 'تسجيل الخروج',
      contact: 'اتصل بنا',
      partnerWithUs: 'كن شريكاً',
    },
    hero: {
      headline: 'موّل أهم لحظات حياتك بطريقتك',
      subtext: 'من رحلات الأحلام إلى الرسوم الدراسية والرعاية الصحية — حوّل النفقات الكبيرة إلى أقساط شهرية بسيطة.',
      cta: 'احصل على وصول مبكر',
      howItWorks: 'كيف يعمل',
    },
    verticals: {
      travel: 'السفر',
      education: 'التعليم',
      healthcare: 'الرعاية الصحية',
    },
    common: {
      perMonth: '/شهر',
      from: 'من',
      bookNow: 'احجز الآن',
      learnMore: 'اعرف المزيد',
      earnPoints: 'اكسب',
      points: 'نقطة',
      aed: 'د.إ',
      sendOTP: 'إرسال رمز التحقق',
      verifyCode: 'تحقق من الرمز',
      signOut: 'تسجيل الخروج',
      getEarlyAccess: 'احصل على وصول مبكر',
    },
    trust: {
      bnplReady: 'جاهز للدفع الآجل',
      flexibleTerms: 'شروط مرنة',
      bankGradeSecurity: 'تشفير 256-بت وآمن',
      securePlatform: 'منصة آمنة',
      bankLevelEncryption: 'تشفير 256-بت وآمن',
      sslProtected: 'محمي بـ SSL',
      yourDataIsSafe: 'بياناتك في أمان',
      licensedPartners: 'شركاء مرخصون',
      uaeRegulatedProviders: 'مزودون منظمون في الإمارات',
      trustedMarketplace: 'سوق موثوق',
      verifiedMerchants: 'تجار معتمدون',
    },
  },
};

export type Language = 'en' | 'ar';
export type TranslationKey = TranslationStrings;
